// src/services/firebase.js
import { initializeApp }  from "firebase/app";
import { getMessaging }   from "firebase/messaging";

const apiKey = import.meta.env.VITE_FIREBASE_API_KEY || "";

export const firebaseConfigured = !!(apiKey && apiKey !== "AIzaSy_placeholder");

const firebaseConfig = {
  apiKey:            import.meta.env.VITE_FIREBASE_API_KEY            || "placeholder",
  authDomain:        import.meta.env.VITE_FIREBASE_AUTH_DOMAIN        || "placeholder.firebaseapp.com",
  projectId:         import.meta.env.VITE_FIREBASE_PROJECT_ID         || "placeholder",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "000000",
  appId:             import.meta.env.VITE_FIREBASE_APP_ID             || "1:000000:web:000000",
};

let _app, _messaging;
try {
  _app = initializeApp(firebaseConfig);
  _messaging = getMessaging(_app);
} catch (e) {
  console.warn("Firebase init failed:", e.message);
}

export const messaging = _messaging;
export default _app;
